<template>
  <el-dialog v-if="showViewer" :visible.sync="showViewer" :show-close="false" :destroy-on-close="true" width="100%" top="0vh">

    <div tabindex="-1" ref="el-image-viewer__wrapper" class="viewer__wrapper" :style="{ 'z-index': zIndex }">
      <!-- <div class="el-image-viewer__mask"></div> -->
      <!-- CLOSE 关闭-->
      <span class="el-image-viewer__btn el-image-viewer__close" @click="hide">
        <i class="el-icon-circle-close"></i>
      </span>
      <!-- ARROW 上一张 下一张 剪头-->
      <template v-if="!isSingle">
        <span
          class="el-image-viewer__btn el-image-viewer__prev"
          :class="{ 'is-disabled': !infinite && isFirst }"
          @click="prev">
          <i class="el-icon-arrow-left"/>
        </span>
        <span
          class="el-image-viewer__btn el-image-viewer__next"
          :class="{ 'is-disabled': !infinite && isLast }"
          @click="next">
          <i class="el-icon-arrow-right"/>
        </span>
      </template>
      <!-- ACTIONS -->
      <div class="el-image-viewer__btn el-image-viewer__actions">
        <div class="el-image-viewer__actions__inner">
          <i class="el-icon-zoom-out cursor" @click="handleActions('zoomOut')" v-if="listData.fileType == 1"></i>
          <i class="el-icon-zoom-in cursor" @click="handleActions('zoomIn')" v-if="listData.fileType == 1"></i>
          <!-- <i class="el-image-viewer__actions__divider cursor" v-if="listData.fileType == 1"></i> -->
          <i class="cursor" :class="mode.icon" @click="toggleMode" v-if="listData.fileType == 1"></i>
          <!-- <i class="el-image-viewer__actions__divider cursor" v-if="listData.fileType == 1"></i> -->
          <!-- <i class="el-icon-refresh-left" @click="handleActions('anticlocelise')"></i>
          <i class="el-icon-refresh-right" @click="handleActions('clocelise')"></i> -->


          <!-- <i class="el-icon-delete cursor" @click="hanldeDelete" v-if="source == 'team' && accessPoint['team:delete']"></i> -->
          <el-tooltip class="item" effect="dark" content="删除" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="hanldeDelete" v-if="source == 'team' && accessPoint['team:delete']">
            <svg-icon class="icon-butn cursor" icon-class="delete_shape" />
          </el-tooltip>

          <!-- <i class="el-icon-s-promotion cursor" v-if="listData.fileType == 1 && accessPoint['allfile:share']" @click="hanldeShare"></i> -->
          <el-tooltip class="item" effect="dark" content="分享" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="hanldeShare" v-if="listData.fileType == 1 && accessPoint['allfile:share']">
            <svg-icon class="icon-butn cursor" icon-class="share_shape" />
          </el-tooltip>

          <!-- <el-tooltip class="item" effect="dark" content="推送" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="hanldePush" v-if="accessPoint['ads:push']">
            <svg-icon class="icon-butn cursor" icon-class="push_shape" />
          </el-tooltip> -->

          <template v-if="source == 'team'">
            <!-- <i class="el-icon-download cursor" @click="handleDownload" v-if="accessPoint['team:download']"></i> -->
            <el-tooltip class="item" effect="dark" content="下载" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="handleDownload" v-if="accessPoint['team:download']">
              <svg-icon class="icon-butn cursor" icon-class="download_shape" />
            </el-tooltip>
          </template>

          <template v-if="source == 'allMaterial'">
            <!-- <i class="el-icon-download cursor" @click="handleDownload" v-if="accessPoint['allfile:download']"></i> -->
            <el-tooltip class="item" effect="dark" content="下载" placement="bottom" :visible-arrow="false" popper-class="tooltip" @click.native="handleDownload" v-if="accessPoint['allfile:download']">
              <svg-icon class="icon-butn cursor" icon-class="download_shape" />
            </el-tooltip>
          </template>

        </div>
      </div>
      <!-- CANVAS -->
      <div class="el-image-viewer__canvas">
        <!-- 视频 -->
        <div class="el-image-viewer__img" ref="video" v-if="listData.fileType == 2" :style="imgStyle" @mousedown="handleMouseDown">
          <video-player :sources="listData"></video-player>
        </div>
      
        <!-- 图片 -->
        <img v-else
          v-for="(url, i) in urlList"
          ref="img"
          class="el-image-viewer__img"
          :key="i"
          :src="currentImg"
          :style="imgStyle"
          @load="handleImgLoad"
          @error="handleImgError"
          @mousedown="handleMouseDown">

        <!-- 说明 -->
        <div class="viewer-text">
          <div class="title">素材详情</div>
          <el-scrollbar wrap-class="scrollbar-wrapper">
            <div class="item" v-if="listData.projectName">
              <label>项目：</label>
              <span>{{listData.projectName}}</span>
            </div>
            <div class="item" v-if="listData.fileName">
              <label>文件名：</label>
              <span>{{listData.fileName}}</span>
            </div>
            <div class="item" v-if="listData.taskName">
              <label>用途：</label>
              <span>{{listData.taskName}}</span>
            </div>
            <div class="item" v-if="listData.gameTypeName">
              <label>游戏类型：</label>
              <span>{{listData.gameTypeName}}</span>
            </div>
            <!-- <div class="item" v-if="listData.designerName || listData.createUserName">
              <label>{{listData.designerName ? '设计师' : '创建人'}}：</label>
              <span>{{listData.designerName ? listData.designerName : listData.createUserName}}</span>
            </div> -->
            <div class="item" v-if="listData.designerName">
              <label>设计师：</label>
              <span>{{listData.designerName}}</span>
            </div>
            <div class="item" v-if="listData.createUserName">
              <label>创建人：</label>
              <span>{{listData.createUserName}}</span>
            </div>
            <div class="item" v-if="listData.size">
              <label>尺寸：</label>
              <span>{{listData.size}}</span>
            </div>
            <div class="item" v-if="listData.size">
              <label>大小：</label>
              <span>{{listData.fileSize | fileSizeFilter}}</span>
            </div>
            <!-- add:商务添加同步网盘图标写死 -->
            <div class="item" v-if="$store.getters.currentRoute.meta.id == 1397">
              <label>同步网盘：</label>
              <svg-icon class="icon" icon-class="success" style='width:20px'/>
            </div>
            <div class="item" v-if="listData.createTimeStr">
              <label>上传时间：</label>
              <span>{{listData.createTimeStr}}</span>
            </div>
            <div class="item" v-if="listData.createTimeStr">
              <label>下载量：</label>
              <span>{{listData.downloads}}</span>
            </div>
            <div class="item" v-if="isPermission">
              <label>添加标签：</label>
              <el-cascader size="small" v-model="labelTags" :options="tagOptions" :props="props" filterable clearable collapse-tags placeholder="请选择标签" style="width:78%"></el-cascader>
            </div>
            <div class="list-box" v-if="isPermission">
              <el-button class="butn" size="mini" type="primary" @click="handleSaveLabels">确定</el-button>
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>

  </el-dialog>
</template>

<script>
import { on, off } from 'element-ui/src/utils/dom';
import { rafThrottle, isFirefox } from 'element-ui/src/utils/util';
import VideoPlayer from './videoPlayer.vue';
import {choiceLabel_ajax,modifyFile_ajax} from '@File~/api/file'

const Mode = {
  CONTAIN: {
    name: 'contain',
    icon: 'el-icon-full-screen'
  },
  ORIGINAL: {
    name: 'original',
    icon: 'el-icon-c-scale-to-original'
  }
};

const mousewheelEventName = isFirefox() ? 'DOMMouseScroll' : 'mousewheel';

export default {
  name: 'elImageViewer',
  components: {VideoPlayer},
  props: {
    showViewer: false,

    urlList: {
      type: Array,
      default: () => []
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    onSwitch: {
      type: Function,
      default: () => {}
    },
    onClose: {
      type: Function,
      default: () => {}
    },
    initialIndex: {
      type: Number,
      default: 0
    },

    listData: {
      type: Object,
      default: () =>{}
    },

    // 来源
    source: {
        type: String,
        default: ''
    },
  },

  data() {
    return {
      index: this.initialIndex,
      isShow: false,
      infinite: true,
      loading: false,
      mode: Mode.CONTAIN,
      transform: {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      },

      isDownLoad: false,

      tagOptions:[],
      props:{ 
          multiple: true,
          expandTrigger: 'hover',
          value:'id',
          label:'name',
          children:'labelList'
      },
      labelTags:[],
      accessPoint: this.$store.getters.accessPoint, //权限点
      isPermission: this.$store.getters.accessPoint['allfile:tagupdate'] // this.$store.getters.userId == '247' || this.$store.getters.userId == '1027' || this.$store.getters.userId == '133',
      
    };
  },
  filters:{
    fileSizeFilter(size) {
      if(size / 1024 / 1024 > 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(2) + 'G'
      } else if(size / 1024 > 1024){
        return (size / 1024 / 1024).toFixed(2) + 'MB'
      } else {
        return (size / 1024).toFixed(2) + 'KB'
      }
    }
  },
  computed: {
    isSingle() {
      return this.urlList.length <= 1;
    },
    isFirst() {
      return this.index === 0;
    },
    isLast() {
      return this.index === this.urlList.length - 1;
    },
    currentImg() {
      return this.urlList[this.index];
    },
    imgStyle() {
      const { scale, deg, offsetX, offsetY, enableTransition } = this.transform;
      const style = {
        transform: `scale(${scale}) rotate(${deg}deg)`,
        transition: enableTransition ? 'transform .3s' : '',
        'margin-left': `${offsetX}px`,
        'margin-top': `${offsetY}px`
      };
      if (this.mode === Mode.CONTAIN) {
        style.maxWidth = style.maxHeight = '80%';
      }
      return style;
    },
  },
  watch: {
    index: {
      handler: function(val) {
        this.reset();
        this.onSwitch(val);
      }
    },
    currentImg(val) {
      this.$nextTick(_ => {
        const $img = this.$refs.img[0];
        if (!$img.complete) {
          this.loading = true;
        }
      });
    }
  },
  methods: {
    hide() {
      this.deviceSupportUninstall();
      this.onClose();
    },
    deviceSupportInstall() {
      this._keyDownHandler = rafThrottle(e => {
        const keyCode = e.keyCode;
        switch (keyCode) {
          // ESC
          case 27:
            this.hide();
            break;
          // SPACE
          case 32:
            this.toggleMode();
            break;
          // LEFT_ARROW
          case 37:
            this.prev();
            break;
          // UP_ARROW
          case 38:
            this.handleActions('zoomIn');
            break;
          // RIGHT_ARROW
          case 39:
            this.next();
            break;
          // DOWN_ARROW
          case 40:
            this.handleActions('zoomOut');
            break;
        }
      });
      this._mouseWheelHandler = rafThrottle(e => {
        const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
        if (delta > 0) {
          this.handleActions('zoomIn', {
            zoomRate: 0.015,
            enableTransition: false
          });
        } else {
          this.handleActions('zoomOut', {
            zoomRate: 0.015,
            enableTransition: false
          });
        }
      });
      on(document, 'keydown', this._keyDownHandler);
      on(document, mousewheelEventName, this._mouseWheelHandler);
    },
    deviceSupportUninstall() {
      off(document, 'keydown', this._keyDownHandler);
      off(document, mousewheelEventName, this._mouseWheelHandler);
      this._keyDownHandler = null;
      this._mouseWheelHandler = null;
    },
    handleImgLoad(e) {
      this.loading = false;
    },
    handleImgError(e) {
      this.loading = false;
      e.target.alt = '加载失败';
    },
    handleMouseDown(e) {
      if(this.listData.type !== 2) {
        if (this.loading || e.button !== 0) return;
      }
      const { offsetX, offsetY } = this.transform;
      const startX = e.pageX;
      const startY = e.pageY;
      this._dragHandler = rafThrottle(ev => {
        this.transform.offsetX = offsetX + ev.pageX - startX;
        this.transform.offsetY = offsetY + ev.pageY - startY;
      });
      on(document, 'mousemove', this._dragHandler);
      on(document, 'mouseup', ev => {
        off(document, 'mousemove', this._dragHandler);
      });

      e.preventDefault();
    },
    reset() {
      this.transform = {
        scale: 1,
        deg: 0,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false
      };
    },
    toggleMode() {
      if (this.loading) return;

      const modeNames = Object.keys(Mode);
      const modeValues = Object.values(Mode);
      const index = modeValues.indexOf(this.mode);
      const nextIndex = (index + 1) % modeNames.length;
      this.mode = Mode[modeNames[nextIndex]];
      this.reset();
    },
    prev() {
      if (this.isFirst && !this.infinite) return;
      const len = this.urlList.length;
      this.index = (this.index - 1 + len) % len;
    },
    next() {
      if (this.isLast && !this.infinite) return;
      const len = this.urlList.length;
      this.index = (this.index + 1) % len;
    },
    handleActions(action, options = {}) {
      if (this.loading) return;
      const { zoomRate, rotateDeg, enableTransition } = {
        zoomRate: 0.2,
        rotateDeg: 90,
        enableTransition: true,
        ...options
      };
      const { transform } = this;
      switch (action) {
        case 'zoomOut':
          if (transform.scale > 0.2) {
            transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
          }
          break;
        case 'zoomIn':
          transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
          break;
        case 'clocelise':
          transform.deg += rotateDeg;
          break;
        case 'anticlocelise':
          transform.deg -= rotateDeg;
          break;
      }
      transform.enableTransition = enableTransition;
    },

    // 下载
    handleDownload() {
      this.$emit('download',this.listData)
    },

    // 分享
    hanldeShare() {
      this.$emit('share',this.listData)
    },

    // 推送
    hanldePush() {
      this.$emit('push',this.listData)
    },

    // 删除
    hanldeDelete() {   
      this.$emit('delete',this.listData)
    },

    // 获取标签列表
    getChoiceLabel() {
      choiceLabel_ajax().then(response => {
          if(response.code == 1) {
              this.tagOptions = response.data
          }
      })
    },

    // 确认添加标签
    handleSaveLabels() {
      let projectIds = []
      let taskIds = []
      let labelIds = []
      this.labelTags.forEach(item => {
          if(item[0] == 'projectIds') {
              projectIds.push(item[1])
          }

          if(item[0] == "taskIds") {
              taskIds.push(item[1])
          }

          if(item[0].indexOf("labelType") > -1) {
              labelIds.push(item[1])
          }
      })
      const data = {
        fileId: this.listData.id,
        projectIds:projectIds,
        labelIds:labelIds,
        taskIds:taskIds,
      }
      modifyFile_ajax(data).then(response => {
        if(response.code == 1) {
          this.$message({
            type: 'success',
            message: '添加成功!'
          });
        }
      })
    }
  },
  mounted() {
    this.deviceSupportInstall();
    // add tabindex then wrapper can be focusable via Javascript
    // focus wrapper so arrow key can't cause inner scroll behavior underneath
    // this.$refs['el-image-viewer__wrapper'].focus();
    // console.log(this.$refs['el-image-viewer__wrapper'])

    this.labelTags = JSON.parse(JSON.stringify(this.listData.choiceLabelValue))
  },
  created() {
    this.getChoiceLabel()
  }
};
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog{
    height: 100vh;
    background:transparent;
    margin: 0;
  }
  ::v-deep .el-dialog__header{
    padding: 0;
  }
  ::v-deep .el-dialog__body{
    width: 100%;
    height: 100vh;
    padding:0;
  }
  .viewer__wrapper{
    width: 100%;
    height: 100vh;
  }
  .el-image-viewer__actions__inner{
    font-size: 18px;
    color: rgba($color: #ffffff, $alpha: .8);
  }
  .el-image-viewer__actions{
    position: fixed;
    width: auto;
    height: 36px;
    background: rgba($color: #000000, $alpha: .8);
    border-radius: 4px;
    padding: 0 12px;
    bottom: 4vh;
    .item{
      width: 16px;
      height: 16px;
      color: rgba($color: #ffffff, $alpha: .8);
    }
  }
  .el-image-viewer__btn{
    position: fixed;
    color: #ffffff;
  }

  .el-image-viewer__canvas{
    position: relative;
  }
  .viewer-text{
    position:absolute;
    top: 10vh;
    right: 5%;
    width:380px;
    height: calc(100vh - 10vh - 10vh);
    background: rgba(0,0,0,.8);
    transform: scale(1) rotate(0deg);
    padding: 20px;
    color: #ffffff;
    .title{
      font-size: 16px;
      line-height: 1.5;
      margin-bottom: 15px;
      text-align: center;
    }
    .item{
      margin: 10px 0;
      line-height: 1.5;
    }
    ::v-deep .el-scrollbar{
      height: calc(100vh - 28vh);
    }
    ::v-deep .scrollbar-wrapper {
      overflow-x: hidden !important;
    }
    .el-scrollbar__bar.is-vertical {
      right: 0px;
    }

    ::v-deep .el-cascader__search-input{
      min-width: 8%;
      margin-left: 5px;
    }
  }

  .cursor{
    cursor: pointer;
    margin: 0 12px;
  }

  .list-box{
    .box{
      margin-top: 20px;
      background:#fff;
      border-radius: 5px;
      box-shadow: 0 0 3px inset rgba(0,0,0,.48);
      padding: 10px;
      .item{
        color:#000000;
      }
    }
    .butn{
      display: block;
      margin: 20px auto;
    }

  }
  
</style>
